import clsx from 'clsx';
import Image from 'components/ui/Image';
import Link from 'components/ui/Link';
import { useTranslation } from 'hooks/useTranslation';
import styles from './PostItem.module.scss';
import type { Image as ImageType } from 'types/Utilities';

type Props = {
  description: string;
  name: string;
  photo: ImageType;
  imageClasses?: string;
  oneLineAuthor?: boolean;
  slug?: string;
  authorBaseSlug?: string | null;
  imageSize?: number;
};

const Author = ({
  description,
  name,
  photo,
  imageClasses = styles.authorImageDefaults,
  imageSize = 32,
  oneLineAuthor,
  slug,
  authorBaseSlug,
}: Props): JSX.Element => {
  const { t, locale } = useTranslation();
  const authorPageLink =
    authorBaseSlug && slug ? `/${locale}/${authorBaseSlug}/${slug}` : '#';

  return (
    <div className={styles.author}>
      <div className={clsx(styles.authorImage, imageClasses)}>
        <Image
          src={photo.url || ''}
          alt={name}
          height={imageSize}
          width={imageSize}
          contentful
        />
      </div>
      <div className={styles.authorContent}>
        {!oneLineAuthor ? (
          <>
            <p>
              <Link
                href={authorPageLink}
                className={styles.authorLink}
                legacyBehavior={false}
              >
                {t('blog.author.by')} <strong>{name}</strong>
              </Link>
            </p>
            <p>{description}</p>
          </>
        ) : (
          <p>
            <Link href={authorPageLink} legacyBehavior={false}>
              <span className={styles.authorLink}>{name}</span>
            </Link>{' '}
            - {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default Author;
